import { Stack } from '@mui/system';
import './Footer.css';

function Footer() {


    return (
        <footer className="bg-white footer text-danger shadow-lg m-footer" >
                <Stack
                    direction={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    padding={'0px 10px'}
                >
                    <img src='/Lilly_logo_footer.png' alt='Footer logo' className='p-1' width={'60px'} height={'40px'}/>
                    <span className="fload-end">&#169; {new Date().getFullYear()} Eli Lilly and Company. All rights reserved.</span>
                </Stack>
        </footer>
    );
}

export default Footer;